// Lista central de modelos de IA suportados (OpenAI/ChatGPT e Google Gemini).
// Mantida em um único lugar para evitar listas dessincronizadas entre os modais.

export const openAiModels = [
  "gpt-4o",
  "gpt-4o-mini",
  "gpt-4.1",
  "gpt-4.1-mini",
  "gpt-4.1-nano",
  "o3",
  "o4-mini",
  "gpt-3.5-turbo-1106",
];

export const geminiModels = [
  "gemini-2.5-pro",
  "gemini-2.5-flash",
  "gemini-2.0-flash",
  "gemini-2.0-pro",
  "gemini-1.5-pro",
  "gemini-1.5-flash",
];

export const allowedModels = [...openAiModels, ...geminiModels];

const modelLabels = {
  "gpt-4o": "GPT-4o",
  "gpt-4o-mini": "GPT-4o mini",
  "gpt-4.1": "GPT-4.1",
  "gpt-4.1-mini": "GPT-4.1 mini",
  "gpt-4.1-nano": "GPT-4.1 nano",
  o3: "OpenAI o3",
  "o4-mini": "OpenAI o4-mini",
  "gpt-3.5-turbo-1106": "GPT-3.5 Turbo",
  "gemini-2.5-pro": "Gemini 2.5 Pro",
  "gemini-2.5-flash": "Gemini 2.5 Flash",
  "gemini-2.0-flash": "Gemini 2.0 Flash",
  "gemini-2.0-pro": "Gemini 2.0 Pro",
  "gemini-1.5-pro": "Gemini 1.5 Pro",
  "gemini-1.5-flash": "Gemini 1.5 Flash",
};

export const getModelLabel = (model) => modelLabels[model] || model;
